export default function Footer() {
  return (
    <footer className="border-t-ink bg-[#0A0A0A] text-[#F4F4F0] mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-3xl md:text-4xl">to be very honest</div>
          <p className="font-quote text-lg mt-3 max-w-md opacity-90">
            A serious archive of unvarnished statements — with a wink. Reference the record. Wear the truth. Book the trip.
          </p>
        </div>
        <div>
          <div className="font-ui text-[11px] mb-3 text-[#FF3333]">Sections</div>
          <ul className="space-y-2 font-body text-sm">
            <li>Home</li><li>Feed</li><li>Shop</li><li>Submit a Quote</li>
          </ul>
        </div>
        <div>
          <div className="font-ui text-[11px] mb-3 text-[#FF3333]">Notes</div>
          <p className="font-body text-sm opacity-80">
            Attributions verified against public record. Corrections welcome. AI Honesty Scores are advisory — not gospel.
          </p>
        </div>
      </div>
      <div className="border-t border-[#333] px-6 md:px-10 py-4 flex flex-wrap items-center justify-between font-mono text-[11px] opacity-70">
        <span>© {new Date().getFullYear()} tobeveryhonest.com</span>
        <span>To be very honest — the internet needed this.</span>
      </div>
    </footer>
  );
}
